'use strict'
import React from 'react'
import PropTypes from 'prop-types'

class Lab extends React.Component {
  render () {
    return (
      <div>
        {this.props.dangerousNonFlicker && this.getInlineMethod()}
        {this.props.children}
      </div>
    )
  }

  getChildContext () {
    return {
      labConfig: {
        dangerousNonFlicker: this.props.dangerousNonFlicker,
        renderOnServer: this.props.renderOnServer
      }
    }
  }

  getInlineMethod () {
    return (
      <script type='text/javascript' dangerouslySetInnerHTML={{__html: `
        var hiddenClass = 'hidden'
        var visibleClass = 'visible'
        var completedClass = 'comp'
        var variantClassPrefix = 'variant-'
        window.experiment = {}
        function selectVariants (name) {
          if (document.cookie && typeof window.experiment[name] === 'undefined') {
            var value = '; ' + document.cookie
            var parts = value.split('; ' + name + '=')
            if (parts.length === 2) {
              window.experiment[name] = {
                chosen: parts.pop().split(';').shift(),
                chosenSelected: false
              }
            }
          }
          if (typeof window.experiment[name] !== 'undefined') {
            var chosenClass = variantClassPrefix + name.toLowerCase() + ' ' + variantClassPrefix + window.experiment[name].chosen.toLowerCase()
            if (document.getElementsByClassName(chosenClass)[0].className.indexOf(visibleClass) < 0 || window.experiment[name].chosenSelected) {
              var variantElements = [].slice.call(document.getElementsByClassName(variantClassPrefix + name.toLowerCase()))
              var elements = []
              variantElements.forEach(function (value) {
                if (value.className.indexOf(completedClass) < 0) {
                  elements.push(value)
                }
              })
              for (i = 0; i < elements.length; i++) {
                var elClassList = elements[i].classList.value.split(" ")
                if (elements[i].className.indexOf(hiddenClass) > -1 && elements[i].className.indexOf(completedClass) < 0 && elClassList[1].split("-")[1].toLowerCase() === window.experiment[name].chosen.toLowerCase()) {
                  elements[i].className = elements[i].className.replace(hiddenClass, visibleClass + ' ' + completedClass)
                  window.experiment[name].chosenSelected = true
                } else if (elements[i].className.indexOf(visibleClass) > -1 && elements[i].className.indexOf(completedClass) < 0) {
                  elements[i].className = elements[i].className.replace(visibleClass, hiddenClass + ' ' + completedClass)
                }
              }
            }
          }

          return null
        }
      `}} />
    )
  }
}

Lab.childContextTypes = {
  labConfig: PropTypes.object
}

Lab.defaultProps = {
  dangerousNonFlicker: false,
  renderOnServer: false
}

Lab.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  dangerousNonFlicker: PropTypes.bool,
  renderOnServer: PropTypes.bool
}

export default Lab
